define(function (require, exports, module) {
    var STRANG = '';

    function ContentTV (tv) {
        this.mediaState = tv.mediaState || STRANG;
        this.id = tv.id || STRANG;
        this.guid = tv.guid || STRANG;
        this.mediaFeedType = tv.mediaFeedType || STRANG;
        this.mediaFeedTypeKey = (tv.mediaFeedType || STRANG).toLowerCase();
        this.callLetters = tv.callLetters || STRANG;
        this.language = tv.language && tv.language.toLowerCase() || STRANG;
        this.freeGame = tv.freeGame || false;
        this.gamePlus = tv.gamePlus || false;
        this.featureContext = tv.featureContext || STRANG;
        this.facebook = tv.facebook || null;
        this.youtube = tv.youtube || null;
    }

    ContentTV.prototype = {

    };

    return ContentTV;
});
